var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("page", [
    _c("div", { staticClass: "page-title" }, [_vm._v("会员配置")]),
    _c(
      "div",
      { staticClass: "page-content", staticStyle: { padding: "0" } },
      [
        _c(
          "el-tabs",
          {
            model: {
              value: _vm.activeTab,
              callback: function ($$v) {
                _vm.activeTab = $$v
              },
              expression: "activeTab",
            },
          },
          [
            _c(
              "el-tab-pane",
              { attrs: { label: "会员等级", name: "memberLevel" } },
              [
                _c(
                  "keep-alive",
                  [
                    _vm.activeTab === "memberLevel"
                      ? _c("MemberLevel", { on: { update: _vm.handleUpdate } })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-tab-pane",
              {
                attrs: {
                  label: "单日提款限制名单",
                  name: "dailyWithdrawLimit",
                },
              },
              [
                _c(
                  "keep-alive",
                  [
                    _vm.activeTab === "dailyWithdrawLimit"
                      ? _c("DailyWithdrawLimit", {
                          on: { update: _vm.handleUpdate },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }